import script from "./CategoriasFinanceirasCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriasFinanceirasCadastro.vue?vue&type=script&setup=true&lang=js"

import "./CategoriasFinanceirasCadastro.vue?vue&type=style&index=0&id=a084110a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a084110a"]])

export default __exports__